module.exports = __webpack_public_path__ + "img/event-icon.4e04d507.png";